import * as tns from "tiny-slider/src/tiny-slider";

function init() {
    InitImageGallery();
}
function InitImageGallery() {
  $(document).ready(() => {
    if (document.querySelector('.image-row__gallery--mobile')) {
      /**/
      var slider = tns({
        container: ".image-row__gallery--mobile",
        items: 2,
        navContainer: "#imageRowNavContainerMobile",
        controls: false,
        mouseDrag: true,
        autoplayHoverPause: false,
        // autoWidth: true,
        // swipeAngle: false,
        autoHeight: true,
        disable: false,
        nav: true,
        touch: true,
        "gutter": 10,
        responsive: {
          1025: {
            disable: true
          }
        }
      });
    }
    if (document.querySelector('.image-row__gallery')) {
      var sliderMain = tns({
        container: ".image-row__gallery",
        items: 2,
        navContainer: "#imageRowNavContainer",
        controls: false,
        mouseDrag: true,
        autoplayHoverPause: false,
        // autoWidth: true,
        // swipeAngle: false,
        autoHeight: true,
        disable: false,
        nav: true,
        touch: true,
        "gutter": 10,
        responsive: {
          1025: {
            disable: true
          }
        }
      });
    }




    if (document.querySelector('.image-row__gallery--desktop')) {

      var sliderAll = tns({
        container: ".image-row__gallery--desktop",
        items: 3,
        navContainer: "#imageRowNavContainerDesktop",
        controls: false,
        responsive: {
          "640": {
            "items": 3,
            "controls": false,
            "edgePadding": 30
          },
          "768": {
            "items": 4,
            "controls": false,
            "edgePadding": 30
          }

        },
        mouseDrag: true,
        autoplay: true,
        autoplayHoverPause: false,
        autoplayButton: '#imageRowPause',
        "autoplayText": [
          "Play",
          "Stop"
        ],
        // autoWidth: true,
        // swipeAngle: false,
        autoHeight: true,
        disable: false,
        nav: false,
        touch: true,
        "gutter": 10,
      });
      /* */
    }

  });

}
export {
    init
}